import type { ReactNode } from 'react';
import { AuthProvider } from '@/features/auth/context/AuthContext';
import { SpinnerProvider, ToastProvider } from '@chikara/ui';
import { ErrorProvider } from '@/shared/components/ErrorProvider';

interface ProvidersProps {
  children: ReactNode;
}

export function Providers({ children }: ProvidersProps) {
  return (
    <ToastProvider>
      <SpinnerProvider>
        <ErrorProvider>
          <AuthProvider>
            {children}
          </AuthProvider>
        </ErrorProvider>
      </SpinnerProvider>
    </ToastProvider>
  );
}

